/* @ngInject */
const railwayIcons = () => {
  const self = {}

  return self
}

export default railwayIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/resources/icons.resource.js